export default "__VITE_ASSET__CC8JRvRX__"